/* Size guide drawer for the 2026 PDP (snippets/pdp2026-size-guide).

   Separate from the inline <script> in size-chart.liquid, which is untouched
   and still serves main-product-pdp2025 and main-product. That script binds
   #sizeChartBtn and #sizeChartPopup; nothing here renders either, so the two
   never both fire -- and the old one's open handler simply finds nothing when
   the 2026 section stops rendering its markup.

   Delegated from document, so the drawer surviving or being replaced by a
   section re-render on a variant change needs no re-binding. */
(function () {
  if (window.Pdp2026SizeGuide) return;

  var OPEN = 'is-open';
  var PORTAL_ID = 'pdp2026-sg-portal';

  function panel() {
    return document.querySelector('[data-pdp2026-sg]');
  }

  function scrims() {
    return document.querySelectorAll('[data-pdp2026-sg-scrim]');
  }

  function header() {
    return document.querySelector('.section-header.shopify-section-group-header-group');
  }

  /* The drawer renders inside product-info's sticky column, which is
     `position: sticky; z-index: 2` -- a stacking context a fixed descendant
     cannot escape, so the site header (z-index 1000) would paint over its
     title however high this panel's z-index goes. Moving the nodes to <body>
     is the fix the rest of the theme already uses. */
  function portalRoot() {
    var root = document.getElementById(PORTAL_ID);
    if (!root) {
      root = document.createElement('div');
      root.id = PORTAL_ID;
      document.body.appendChild(root);
    }
    return root;
  }

  function portal() {
    var root = portalRoot();
    var nodes = document.querySelectorAll('[data-pdp2026-sg], [data-pdp2026-sg-scrim]');
    var fresh = [];

    for (var i = 0; i < nodes.length; i++) {
      /* Only nodes still where Liquid rendered them. A section re-render makes
         a fresh set beside the ones already moved, so finding any here means
         the portal holds a stale copy -- empty it before refilling. Finding
         none means everything is in place and this is a no-op. */
      if (!root.contains(nodes[i])) fresh.push(nodes[i]);
    }
    if (!fresh.length) return;

    root.replaceChildren();
    for (var j = 0; j < fresh.length; j++) root.appendChild(fresh[j]);
  }

  function close() {
    var p = panel();
    if (p) p.classList.remove(OPEN);
    scrims().forEach(function (s) {
      s.classList.remove(OPEN);
    });
    var head = header();
    if (head) head.classList.remove('product--info--drawer--open--now');
    document.body.classList.remove('scroll_lock');
  }

  function open() {
    portal();
    var p = panel();
    if (!p) return;

    p.classList.add(OPEN);
    scrims().forEach(function (s) {
      s.classList.add(OPEN);
    });
    var head = header();
    if (head) head.classList.add('product--info--drawer--open--now');
    document.body.classList.add('scroll_lock');

    var btn = p.querySelector('[data-pdp2026-sg-close]');
    if (btn) btn.focus();
  }

  function selectTab(name) {
    var p = panel();
    if (!p) return;
    p.setAttribute('data-pdp2026-sg-tab', name);
    p.querySelectorAll('[data-pdp2026-sg-tab-btn]').forEach(function (btn) {
      btn.setAttribute(
        'aria-selected',
        btn.getAttribute('data-pdp2026-sg-tab-btn') === name ? 'true' : 'false'
      );
    });
  }

  /* Each value carries every unit as a data attribute, rendered by Liquid, so
     switching is a text swap with no arithmetic and no rounding drift. The
     toggle is per pane: rings run mm/in, belts in/cm. */
  function selectUnit(button) {
    var unit = button.getAttribute('data-pdp2026-sg-unit');
    var pane = button.closest('[data-pdp2026-sg-pane]');
    if (!unit || !pane) return;

    pane.querySelectorAll('[data-pdp2026-sg-unit]').forEach(function (other) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });

    pane.querySelectorAll('.pdp2026-sg__value').forEach(function (cell) {
      var next = cell.getAttribute('data-' + unit);
      if (next !== null && cell.textContent !== next) cell.textContent = next;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-pdp2026-size-guide], #sizeChartBtn')) {
      open();
      return;
    }

    var tab = target.closest('[data-pdp2026-sg-tab-btn]');
    if (tab) {
      selectTab(tab.getAttribute('data-pdp2026-sg-tab-btn'));
      return;
    }

    var unit = target.closest('[data-pdp2026-sg-unit]');
    if (unit) {
      selectUnit(unit);
      return;
    }

    if (target.closest('[data-pdp2026-sg-close]') || target.closest('[data-pdp2026-sg-scrim]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.addEventListener('shopify:section:load', portal);

  window.Pdp2026SizeGuide = { open: open, close: close, portal: portal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portal);
  } else {
    portal();
  }
})();
